import { present } from 'shared/presenters/presenter'
import { Children } from 'shared/presenters/graphqlTypes'

export class ChildPresenter extends present<Children>() {}
